export default function randomNumber(min, max) {
		min = Math.ceil(min);
		max = Math.floor(max);
		//The maximum is exclusive and the minimum is inclusive
		return Math.floor(Math.random() * (max - min)) + min;
	}
